import { useNavigate } from "react-router";

import BrandPage from "../components/BrandPage";
import Brand from "../domain/Brand";
import BrandEditor from "../features/BrandEditor";

export default function CreateBrand() {
    const navigate = useNavigate();

    function onSave(brand: Brand) {
        navigate(`../${ brand.id }`);
    }

    return (
        <BrandPage>
            <header>
                <span>Brand</span>
            </header>
            <BrandEditor
                brand={ new Brand({}) }
                onSave={ onSave }
            />
        </BrandPage>
    );
}
